import { TextField, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { Controller } from "react-hook-form";
import style from "./Input.module.css";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const FormInputText = ({
  name,
  label,
  control,
  rules,
  error,
  type,
  width,
  required,
  helpText,
  disabled = false,
  onChange = () => void 0,
}) => {
  return (
    <Box className={style.control} sx={{ display: "flex", gap: "0.25rem" }}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <TextField
            required={required}
            type={type}
            fullWidth
            size="small"
            {...field}
            label={label}
            error={error !== undefined}
            helperText={error}
            sx={{ width: `${width}%` }}
            disabled={disabled}
            onChange={(e) => {
              field.onChange(e.target.value);
              onChange();
            }}
          />
        )}
      />
      {helpText && (
        <Tooltip title={helpText}>
          <InfoOutlinedIcon fontSize="small" color="secondary" />
        </Tooltip>
      )}
    </Box>
  );
};

export default FormInputText;
